import { Card, CardBody, CardFooter, Input } from "reactstrap";
import { formatNumberWithCommas } from "../../helpers/helpers";

const PurchaseTotalCard = ({
  height,
  totalTaxAmount,
  setTotalTaxAmount,
  subTotal,
  total,
}) => {
  const handleInputChange = (e, field) => {
    let { value } = e.target;

    if (value === "" || isNaN(value)) {
      value = 0;
    }

    setTotalTaxAmount({
      ...totalTaxAmount,
      [field]: value,
    });
  };
  const renderItems = () => {
    return (
      <>
        <div className="d-flex justify-content-between align-items-center  mb-3">
          <p className="mb-0">Sub Total</p>
          <p className="mb-0">{formatNumberWithCommas(subTotal ?? 0)}</p>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <p className="mb-0">Sales Tax</p>
          <Input
            style={{ width: "150px", height: "30px" }}
            value={totalTaxAmount?.tax}
            className="rounded-0"
            type={"number"}
            min={0}
            onChange={(e) => handleInputChange(e, "tax")}
            onBlur={(e) => {
              if (!e.target.value) e.target.value = 0;
            }}
          />
        </div>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <p className="mb-0">Shipping</p>
          <Input
            style={{ width: "150px", height: "30px" }}
            value={totalTaxAmount?.shipping}
            className="rounded-0"
            type={"number"}
            min={0}
            onChange={(e) => handleInputChange(e, "shipping")}
            onBlur={(e) => {
              if (!e.target.value) e.target.value = 0;
            }}
          />
        </div>
      </>
    );
  };
  return (
    <Card
      className="bg-secondary-color border-1 rounded-0"
      style={{ height: `${height} !important` }}
    >
      <CardBody>{renderItems()}</CardBody>
      <CardFooter>
        <div className="d-flex justify-content-between align-items-center primary-color fw-bold">
          <p>Total</p>
          <p>
            $
            {total != null && !isNaN(Number(total))
              ? formatNumberWithCommas(Number(total).toFixed(2))
              : 0}
          </p>
        </div>
      </CardFooter>
    </Card>
  );
};

export default PurchaseTotalCard;
